import '../../themes/caviar/color/index.js';
import '../../themes/caviar/borderRadius/index.js';
import { TextStyleSemanticsAll } from '../../themes/caviar/textStyle/textStyle-semantics.js';
import { Brands } from '../constants.js';
import '../../themes/caviar/shape/index.js';
import { BorderRadiusSemanticsAll } from '../../themes/caviar/borderRadius/borderRadius-semantics.js';
import { ColorSemanticsAll } from '../../themes/caviar/color/color-semantics.js';
import { ShapeSemanticsAll } from '../../themes/caviar/shape/shape-semantics.js';
import { ColorTokensAll } from '../../themes/caviar/color/color-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var caviarColorsExport = function caviarColorsExport() {
  var CaviarColorTokens = ColorTokensAll;
  var CaviarColors = {};
  var keys = Object.keys(ColorTokensAll);
  keys.forEach(function (tokenName) {
    var keyName = tokenName.replace('SystemCaviar', '');
    CaviarColors[keyName] = CaviarColorTokens[tokenName];
  });
  return CaviarColors;
};

var CaviarColors = caviarColorsExport();
var CaviarOverrides = {
  BorderRadius: _objectSpread({}, BorderRadiusSemanticsAll),
  Colors: _objectSpread({}, ColorSemanticsAll),
  Icons: {
    Brand: Brands.Caviar
  },
  Logo: {
    Brand: Brands.Caviar
  },
  Shape: _objectSpread({}, ShapeSemanticsAll),
  Typography: {
    FontFamily: 'Caviar-Market',
    TextStyles: _objectSpread({}, TextStyleSemanticsAll)
  }
};

export { CaviarColors, CaviarOverrides };
